import ProductDefault from './ProductDefault'
import ProductModal from './ProductModal'
import ProductPage from './ProductPage'
import ProductTabContent from './ProductTabContent'
import ProductVariations from './ProductVariations'
import ProductCustomization from './ProductCustomization'
import ModalTellMeWhenYouArrive from './ModalTellMeWhenYouArrive'

export default {
    'product-default': ProductDefault,
    'product-modal': ProductModal,
    'product-page': ProductPage,
    'product-tab-content': ProductTabContent,
    'product-variations': ProductVariations,
    'product-customization': ProductCustomization,
    'modal-tell-me-when-you-arrive': ModalTellMeWhenYouArrive
}
